// extracted by mini-css-extract-plugin
export default {"ellipsizeLeft":"Breadcrumb_ellipsizeLeft__aekME"};